import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { RadioButton } from "../../atoms/RadioButtonInput";
import { Label } from "../../atoms/Label";
import { InlineErrorMessage } from "@components/atoms/Errors/InlineErrorMessage";

export type RadioOptionsProps = {
  id: string;
  className?: string;
  name?: string;
  labelTextOptionOne: string;
  labelTextOptionTwo: string;
  title?: string;
  errorMessage?: string;
  onChange: (result: string) => void;
};
export type ResetCheckedStateHandle = {
  resetCheckedState: () => void;
};
export const RadioInputOptions = forwardRef<
  ResetCheckedStateHandle,
  RadioOptionsProps
>((props, ref) => {
  const [yesRadioChecked, setYesRadioChecked] = useState(false);
  const [noRadioChecked, setNoRadioChecked] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);

  useImperativeHandle(ref, () => ({
    resetCheckedState() {
      setYesRadioChecked(false);
      setNoRadioChecked(false);
    },
  }));

  return (
    <div className="mb-1 mt-4">
      <div className="mb-6 text-2xl font-semibold">{props.title}</div>
      <InlineErrorMessage message={props.errorMessage} />
      <div className="mt-4 flex items-center">
        <RadioButton
          id={props.id + `dynamic-yes`}
          data-radiobutton="dynamic-yes"
          name={(props.name || "") + "dynamic-yes"}
          value="true"
          ref={inputRef}
          checked={yesRadioChecked}
          onChange={() => {
            setNoRadioChecked(false);
            setYesRadioChecked(!yesRadioChecked);
            props.onChange(props.labelTextOptionOne);
          }}
        />
        <Label
          className="radio-label"
          htmlFor={props.id + "dynamic-yes"}
          text={props.labelTextOptionOne}
        />
      </div>
      <div className="mt-6 flex items-center">
        <RadioButton
          id={props.id + `dynamic-no`}
          data-radiobutton="dynamic-no"
          name={(props.name || "") + "dynamic-no"}
          ref={inputRef}
          value="false"
          checked={noRadioChecked}
          onChange={() => {
            setYesRadioChecked(false);
            setNoRadioChecked(!noRadioChecked);
            props.onChange(props.labelTextOptionTwo);
          }}
        />
        <Label
          className="radio-label"
          htmlFor={props.id + "dynamic-no"}
          text={props.labelTextOptionTwo}
        />
      </div>
    </div>
  );
});

RadioInputOptions.displayName = "RadioInputOptions";
